import {useEffect} from "react";

import {PageLayout} from "base/layout";
import {useStatsConfig} from "stats/provider";
import {StatsInfrastructureTypeFilter} from "stats/presentational";
import ViewStatsInfrastructuresTypeChart from "./ViewStatsInfrastructuresTypeChart";

import Stack from "@mui/material/Stack";
import {SectionCard} from "base/component/presentational";
import {useLocation} from "react-router-dom";
import {useAppConfig} from "base/provider";
import Alert from "@mui/material/Alert";

const ViewStatsInfrastructuresTypeSubPage = ({sector}) => {
    const {setPagePath} = useAppConfig();
    const {statsFilter, setStatsFilter} = useStatsConfig();

    const location = useLocation();
    const path = location.pathname
        .split("/")
        .slice(-1)
        .pop();

    useEffect(() => {
        setPagePath([
            {
                name: `Por atributo (${
                    path === "saneamento_infrastructures_count"
                        ? "Saneamento"
                        : "Abastecemento"
                })`,
                path,
            },
        ]);
        return () => {
            setPagePath([]);
        };
    }, [location.pathname]);

    const handleFilterChange = filter => {
        setStatsFilter(filter);
    };

    useEffect(() => {
        setStatsFilter(null);
    }, [sector]);

    return (
        <PageLayout subPage={true}>
            <Stack spacing={2} sx={{width: "100%"}}>
                <StatsInfrastructureTypeFilter
                    filter={statsFilter}
                    onChange={handleFilterChange}
                />
                <SectionCard title="Estadísticas de infraestructuras por atributo">
                    {statsFilter?.infrastructure_type && statsFilter?.attribute ? (
                        <ViewStatsInfrastructuresTypeChart statsFilter={statsFilter} />
                    ) : (
                        <Alert severity="warning">
                            Seleccione o <b>atributo</b> e o{" "}
                            <b>tipo de infraestructura</b> no filtro
                        </Alert>
                    )}
                </SectionCard>
            </Stack>
        </PageLayout>
    );
};
export default ViewStatsInfrastructuresTypeSubPage;
